import angular from 'angular';
import gridHeight from '../core/shared-service/grid-utils';
import _ from 'lodash';

const ERROR_MESSAGE_MAP = {
    DUPLICATE_CONTACT_SELLER_EMAIL: 'error.duplicate_contact_email',
    UNAUTHORIZED_DOMAIN_NAME_EMAIL: 'error.user_unauthorised_domain_name_mail',
    USER_GED_AUTH_WITHOUT_OTHER_BUYER: 'error.functional.ged_auth_without_other_buyer',
    USER_GED_AUTH_NOT_DEFAULT_GROUP: 'error.functional.ged_auth_not_default_group',
    GED_ACCOUNT_UPDATE_FAILED: 'error.functional.ged_account_update_failed',
    USER_GROUP_WKF_ORDER_ENTRY_PROFILE_WITHOUT_EXECUTIVE_INVBUY:
        'error.functional.usr_group_wkf_order_entry_profile_without_executive_invbuy',
};

// TODO revoir ce composant pour enlever le isConsult
class UserCtrl {
    /* @ngInject */
    constructor(
        $window,
        $uibModal,
        $translate,
        logger,
        EMAIL_REGEXP,
        KISS_USER,
        KissUserSvc,
        PrincipalSvc,
        UserBo,
        LegalEntityGroupUser,
        $sessionStorage,
        AppSvc
    ) {
        this.$window = $window;
        this.translate = $translate;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.KISS_USER = KISS_USER;
        this.KissUserSvc = KissUserSvc;
        this.UserBo = UserBo;
        this.$uibModal = $uibModal;
        this.PrincipalSvc = PrincipalSvc;
        this.LegalEntityGroupUser = LegalEntityGroupUser;
        this.$sessionStorage = $sessionStorage;
        this.AppSvc = AppSvc;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };

        var ctrl = this;
        ctrl.status = this.KISS_USER.status;
        ctrl.userBo = angular.copy(ctrl.userBoData);
        ctrl.langs = ctrl.PrincipalSvc.getLangs();
        ctrl.emailConfirm = angular.copy(ctrl.userBo.user.email);
        ctrl.profiles = this.getWrkFlowProfiles();
        ctrl.mainDivClass = 'col-md-10 col-sm-offset-1';
        const defaultCellTemplate = `<div class="ui-grid-cell-contents" ng-class="row.entity.legalEntityGroup.type === 'ALL' ? 'legal-entity-group-all' : ''">{{COL_FIELD CUSTOM_FILTERS}}</div>`;
        const profileCellTemplate = `<div class="ui-grid-cell-contents" ng-class="row.entity.legalEntityGroup.type === 'ALL' ? 'legal-entity-group-all' : ''">{{grid.appScope.$ctrl.getProfileLabel(row.entity) CUSTOM_FILTERS}}</div>`;
        const deleteCellTemplate =
            '<div class="ui-grid-cell-contents text-center pointer" ng-if="!(grid.appScope.$ctrl.isSingleAdminFo && row.entity.isAdminFo()) && grid.appScope.$ctrl.isInactivable(row.entity)"' +
            'ng-click="grid.appScope.$ctrl.deleteAuthorization(row.entity)"><span><i class="fa fa-trash"></i></span>&nbsp;</div>';
        var searchCellTemplate =
            '<div class="ui-grid-cell-contents text-center pointer"' +
            'ng-click="grid.appScope.$ctrl.openModalSubEntity(row.entity)"><span><i class="fa fa-search"></i></span>&nbsp;</div>';
        const sortWithGroupAllFirst = function (a, b, rowA, rowB, direction) {
            let d;
            if (rowA.entity.legalEntityGroup.type === 'ALL' || a === null || a === undefined) {
                d = direction === 'asc' ? -1 : 1;
            } else if (rowB.entity.legalEntityGroup.type === 'ALL' || b === null || b === undefined) {
                d = direction === 'asc' ? 1 : -1;
            } else if (typeof a === 'number') {
                d = a - b;
            } else {
                d = a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
            }
            return d;
        };
        // Gestion de la grille
        ctrl.gridOptions = {
            columnDefs: [
                {
                    name: 'legalEntityGroup.principalName',
                    displayName: 'Entreprise',
                    sortingAlgorithm: sortWithGroupAllFirst,
                    cellTemplate: defaultCellTemplate,
                    visible: !!ctrl.isConsult() && !ctrl.isCreate(),
                },
                {
                    name: 'legalEntityGroup.name',
                    displayName: 'Groupe',
                    sortingAlgorithm: sortWithGroupAllFirst,
                    cellTemplate: defaultCellTemplate,
                    sort: { direction: 'asc', priority: 0 },
                },
                {
                    name: 'role',
                    displayName: 'Profil',
                    sortingAlgorithm: sortWithGroupAllFirst,
                    cellTemplate: profileCellTemplate,
                },
                {
                    name: 'search',
                    displayName: '',
                    width: '50',
                    cellTemplate: searchCellTemplate,
                    enableSorting: false,
                    visible: true,
                },
                {
                    name: 'delete',
                    displayName: '',
                    width: '50',
                    cellTemplate: deleteCellTemplate,
                    enableSorting: false,
                    visible: !ctrl.isConsult(),
                },
            ],
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                ctrl.gridApi = gridApi;
            },
        };
        ctrl.gridOptions.data = ctrl.userBo.user && this.moveDefaultGroupToHead(ctrl.userBo.user.legalEntityGroupUsers);
        ctrl.sso = ctrl.getSsoStatus();
        ctrl.userBo.user.language = ctrl.userBo.user.language
            ? ctrl.userBo.user.language
            : ctrl.principal.detail.langCode;
    }

    getWrkFlowProfiles() {
        const profiles = new Array();

        if (this.legalEntity && this.legalEntity.id) {
            this.KissUserSvc.getOrderWorkflowProfiles(this.legalEntity.id).then(wrkFlwProfiles =>
                profiles.push(...wrkFlwProfiles)
            );
        } else if (this.userBo && this.userBo.user && this.userBo.user.id && this.isThreeWayMatchingPcp()) {
            this.KissUserSvc.getWorkflowProfilesByUser(this.userBo.user.login).then(wrkFlwProfiles =>
                profiles.push(...wrkFlwProfiles)
            );
        }

        if (this.isThreeWayMatchingPcp()) {
            this.KissUserSvc.getWorkflowProfiles(this.principal.detail.id).then(threeWayProfile =>
                profiles.push(...threeWayProfile)
            );
        }

        return profiles;
    }

    /**
     * Permet de savoir si le DO dispose d'un rapprochement 3 voies.
     * @returns true si c'est vrai, false sinon.
     */
    isThreeWayMatchingPcp() {
        return this.principal && this.principal.detail && this.principal.detail.threeWayMatching;
    }

    getOrderWrkFlowProfiles() {
        return this.profiles.filter(p => p.type && p.type === 'ORDER_ENTRY');
    }

    $onDestroy() {
        this.$sessionStorage.isdetailUserFromKissList = null;
    }

    getSsoStatus() {
        return this.userBo.user.login !== null && this.userBo.user.domain !== null ? 'SSO_ENABLED' : 'SSO_DISABLED';
    }

    /*
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    getProfileLabel(legalEntityGroupUser) {
        if (legalEntityGroupUser.isWorkflowProfile()) {
            const profile = this.profiles.find(
                p => p.code === legalEntityGroupUser.wkfProfile && p.workflowScope === legalEntityGroupUser.wkfScope
            );
            return profile && profile.label ? profile.label : legalEntityGroupUser.wkfProfile;
        } else {
            return legalEntityGroupUser.getRoleLabel();
        }
    }

    hasWorkflowProfile(groups) {
        return groups.find(g => g.isWorkflowProfile());
    }

    /**
     * Met les groupes par défaut à la tête de la liste.
     * @param {list} legalEntityGroupUsers
     */
    moveDefaultGroupToHead(legalEntityGroupUsers) {
        if (!legalEntityGroupUsers || legalEntityGroupUsers.length <= 1) {
            return legalEntityGroupUsers;
        }
        const defaultArr = _.remove(legalEntityGroupUsers, leg => leg.legalEntityGroup.type === 'ALL');
        const sortedDefautltArr = _.sortBy(defaultArr, d => d.role);
        sortedDefautltArr.forEach(sda => legalEntityGroupUsers.unshift(sda));
        return legalEntityGroupUsers;
    }

    openGroupsModal() {
        const ctrl = this;
        this.$uibModal
            .open({
                component: 'modal-add-kiss-user-authorization',
                size: 'md',
                resolve: {
                    groups: () => ctrl.groups,
                    principal: () => ctrl.principal,
                    legalEntity: () => ctrl.legalEntity,
                    mustBeAdminFo: () => ctrl.mustBeAdminFo,
                    profiles: () => ctrl.gridOptions.data,
                    wkfProfiles: () => ctrl.getOrderWrkFlowProfiles(),
                },
            })
            .result.then(
                // TODO  rafraichir la liste pour avoir le nom de l'entreprise
                authrorization => {
                    var found = _.find(ctrl.gridOptions.data, data => {
                        if (data.role === 'USER_WKF') {
                            return (
                                data.role === authrorization.role &&
                                data.wkfScope === authrorization.wkfScope &&
                                data.wkfProfile === authrorization.wkfProfile &&
                                data.legalEntityGroup.id === authrorization.legalEntityGroup.id
                            );
                        } else {
                            return (
                                data.role === authrorization.role &&
                                data.legalEntityGroup.id === authrorization.legalEntityGroup.id
                            );
                        }
                    });
                    if (!found) {
                        ctrl.gridOptions.data = this.moveDefaultGroupToHead(
                            ctrl.gridOptions.data.concat(authrorization)
                        );
                        ctrl.gridOptions.totalItems = ctrl.gridOptions.data.length;
                        this.form.$setDirty();
                    }
                },
                () => {}
            );
    }

    openModalSubEntity(authorization) {
        const ctrl = this;
        const group =
            this.groups.find(grp => grp.id === authorization.legalEntityGroup.id) || authorization.legalEntityGroup;
        this.$uibModal.open({
            component: 'modal-group-list-sub-entities',
            size: 'xl',
            resolve: {
                entities: () =>
                    ctrl.PrincipalSvc.getGroupData(this.principal.detail.id, authorization, group).then(data => data),
                cols: () => ctrl.PrincipalSvc.getGroupColumns(group),
                legalEntityGroup: () => authorization.legalEntityGroup.id,
                legalEntity: () => this.principal.detail.id,
                desc: () => group.description,
                title: () => ctrl.PrincipalSvc.getGroupTitle(group),
                isSubEntity: () => group.nbDivisions > 0 || group.nbSubEntities > 0,
            },
            backdrop: 'static',
        });
    }

    deleteAuthorization(authorization) {
        if (this.gridOptions.data.length === 1) {
            const message = this.translate.instant('kiss_user.edit.confirm.disable', {
                login: this.userBo.user.login,
                name: this.userBo.user.lastname,
            });
            this.openConfirmDeleteAllAuthorization(authorization, message);
        } else if (
            this.gridOptions.data.filter(data => data.legalEntityGroup.principalName === this.getOwnerEntity())
                .length === 1
        ) {
            const message = this.translate.instant('kiss_user.edit.confirm.remove_from_seller', {
                login: this.userBo.user.login,
                name: this.userBo.user.lastname,
                seller: this.getOwnerEntity(),
            });
            this.openConfirmDeleteAllAuthorization(authorization, message);
        } else {
            this.deleteAuthorizationConfirmed(authorization);
        }
    }

    deleteAuthorizationConfirmed(authorization) {
        const index = this.gridOptions.data.findIndex((element) => element.id === authorization.id)
        this.gridOptions.data.splice(index, 1);
        this.gridOptions.totalItems = this.gridOptions.data.length;
        this.form.$setDirty();
    }

    saveUser() {
        if (this.form.$valid) {
            if (this.userBo.user.login === null) {
                const message = this.translate.instant('kiss_user.edit.confirm.create_new', {
                    firstname: this.userBo.user.firstname,
                    lastname: this.userBo.user.lastname,
                    email: this.userBo.user.email,
                });

                this.$uibModal
                    .open({
                        component: 'confirmationModal',
                        size: 'md',
                        resolve: {
                            modalTitle: () => {
                                return { value: 'kiss_user.edit.confirm.create_new_title' };
                            },
                            modalMessage: () => {
                                return [{ key: message }];
                            },
                            modalCancelButtonText: () => {
                                return { value: 'commons.cancel' };
                            },
                            modalConfirmButtonText: () => {
                                return { value: 'commons.ok' };
                            },
                        },
                        backdrop: 'static',
                        keyboard: false,
                    })
                    .result.then(
                        () => this.saveUserAction(),
                        () => {}
                    );
            } else {
                this.saveUserAction();
            }
        }
    }

    saveUserAction() {
        this.userBo.user.legalEntityGroupUsers = this.gridOptions.data;
        this.userBo.user.ownerEntityType = this.principal.detail.profilBuyerInvited
            ? this.KISS_USER.userOwnerEntityType.find(type => type === 'BUYER')
            : this.KISS_USER.userOwnerEntityType.find(type => type === 'SELLER');

        this.PrincipalSvc.saveUser(this.principal.detail.id, this.userBo.user).then(
            () => {
                this.$window.history.back();
                if (this.userBo.user.login !== null) {
                    this.logger.success('success.update', null, null, { entityName: "L'utilisateur" });
                } else {
                    this.logger.success('success.create_user');
                }
            },
            error => {
                var errorMessage = 'error.update';
                if (error.status === 400 && error.data) {
                    errorMessage = ERROR_MESSAGE_MAP.hasOwnProperty(error.data.code)
                        ? ERROR_MESSAGE_MAP[error.data.code]
                        : 'error.create';
                }
                this.logger.error(errorMessage, error);
            }
        );
    }

    changeStatus(status) {
        this.KissUserSvc.changeStatus(status, this.userBo.user).then(
            () => {
                // Nothing to do
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'DUPLICATE_CONTACT_SELLER_EMAIL') {
                    this.logger.error('error.duplicate_contact_email', error, null, null, 10000);
                } else {
                    this.logger.error('error.update', error);
                }
            }
        );
    }

    canUnlock() {
        return this.userBo.user.isLocked();
    }

    cancelChanges() {
        this.userBo = angular.copy(this.userBoData);
        this.emailConfirm = this.userBo.user.login !== null ? this.userBo.user.email : null;
        this.gridOptions.data = this.userBo.user && this.userBo.user.legalEntityGroupUsers;
        this.form.$setPristine();
    }

    getOwnerEntity() {
        let entity = null;
        if (this.principal) {
            entity = this.principal.detail.corporateName;
        }
        return entity;
    }

    isPrincipalProfile() {
        return this.principal.detail.profilSeller || this.principal.detail.profilBuyer;
    }

    isConsult() {
        return this.$sessionStorage.isdetailUserFromKissList;
    }

    isCreate() {
        return this.userBo.user.login === null;
    }

    //FIXME : à corriger
    isInactivable(authorization) {
        return !(this.userBo.user.action === 'REGISTRATION' && authorization.isDefaultGroup());
    }

    isReadOnly() {
        return !this.isCreate() && !!this.userBo.user.lastConnectionDate;
    }

    canCreatImpersonatedUser() {
        return (
            this.userBo.user.action !== 'REGISTRATION' &&
            (this.userBo.user.isActive() || this.userBo.user.isLocked()) &&
            !this.isImpersonatedUser() &&
            !this.userBo.user.isUserWrkFlowOnly()
        );
    }

    // Popup affichée dans le cas où on retire toutes les autorisations de l'utilisateur.
    openConfirmDeleteAllAuthorization(authorization, message) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'commons.confirm' };
                    },
                    modalMessage: () => {
                        return [{ key: message }];
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.ok' };
                    },
                    data: () => {
                        return authorization;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                authorization => this.deleteAuthorizationConfirmed(authorization),
                () => {}
            );
    }

    disableSave() {
        return this.userBo.user.login === null && this.gridOptions.data.length === 0;
    }

    isImpersonatedUser() {
        return this.userBo && this.userBo.user && this.userBo.user.roles
            ? this.userBo.user.roles.some(role => role === 'IMPERSONATED')
            : false;
    }

    canDisplayed() {
        return (this.userBo.user.lastConnectionDate === null || !this.isConsult()) && !this.isImpersonatedUser();
    }

    creatImpersonatedUser() {
        this.componentsUrls = this.AppSvc.getSyComponentsUrls();
        this.KissUserSvc.createImpersonatedUser(this.userBo.user.id).then(
            impersonatedUser => {
                this.$uibModal
                    .open({
                        component: 'impersonateUserModal',
                        size: 'md',
                        resolve: {
                            modalUser: () => impersonatedUser,
                            componentsUrls: () => this.componentsUrls,
                            modalUserFrom: () => this.userBo.user,
                        },
                        backdrop: 'static',
                        keyboard: false,
                    })
                    .result.then(
                        () => {},
                        () => {}
                    );
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }
}

angular.module('app.kissuser').component('userDetail', {
    templateUrl: require('./kiss-user-detail.html'),
    controller: UserCtrl,
    bindings: {
        principal: '<',
        legalEntity: '<',
        groups: '<',
        userBoData: '<',
        isSingleAdminFo: '<',
    },
});
